import { render, staticRenderFns } from "./UserDoubleDegreeAgreement.vue?vue&type=template&id=1aa6325f"
import script from "./UserDoubleDegreeAgreement.vue?vue&type=script&lang=js"
export * from "./UserDoubleDegreeAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports